import React, { useEffect, useState, useRef } from "react";
import {
  Alert,
  Box,
  Button,
  Chip,
  Drawer,
  FormControl,
  FormHelperText,
  FormLabel,
  Grid,
  IconButton,
  Snackbar,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import * as Yup from "yup";
import { useFormik } from "formik";
import CustomInput from "../../components/CustomInput";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import { appLogger } from "../../utils";

interface IProps {
  [x: string]: any;
  addOpen: boolean;
  setClosePopup: Function;
  createGroup: Function;
  setPushDatatoList: any;
}

const GroupForm = (props: IProps) => {
  appLogger.info({
    infoObj: {
      method: "GroupForm",
      component: "groups",
      fileName: "groupForm.tsx",
      props: props,
    },
  });
  const { productLists } = props;
  const tmpProd = JSON.parse(JSON.stringify(productLists));
  const [groupProdList, setGroupProdList] = useState(tmpProd);

  const filteredProdList = (selectedGroup: any, selectedProd: any) => {
    appLogger.info({
      infoObj: {
        method: "filteredProdList",
        component: "groups",
        fileName: "groupForm.tsx",
        groupProdList: groupProdList,
      },
    });
    const filteredProd: any[] = groupProdList.filter(
      (el: { groups: string | any[]; id: string | any }) => {
        if (el && el.groups && el.groups.length > 0) {
          return false;
        }
        return true;
      }
    );
    return filteredProd;
  };

  const [subGrouprowsData, setsubGrouprowsData] = useState<any>(
    props.editData.subGroups ? props.editData.subGroups : []
  );

  useEffect(() => {
    setGroupProdList([...tmpProd]);
  }, [props.addOpen]);

  const validationSchema = Yup.object({
    id: Yup.string(),
    name: Yup.string(),
    products: Yup.array(),
    subGroups: Yup.array(),
  });

  const initialValues = {
    id: props.editData.id ? props.editData.id : "",
    name: props.editData.name ? props.editData.name : "",
    products: props.editData.products ? props.editData.products : "",
    subGroups: props.editData.subGroups ? props.editData.subGroups : "",
  };

  const handleDrawerClose = () => {
    setGroupProdList([...tmpProd]);
    props.setClosePopup(false);
  };

  const [alertOpen, setAlertOpen] = React.useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isLoading, setIsloading] = React.useState(false);

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleErrorAlertClose = () => {
    setErrorAlertOpen(false);
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: async (values) => {
      if (values && values.subGroups) {
        values.subGroups = values.subGroups.filter(
          (item: any) => item.name.trim() !== ""
        );
      }
      try {
        appLogger.info({
          infoObj: {
            method: "useFormik",
            component: "groups",
            fileName: "groupForm.tsx",
            values: values,
          },
        });
        let error = false;
        subGrouprowsData.map((element: any) => {
          appLogger.info({
            infoObj: {
              method: "useFormik",
              component: "groups",
              fileName: "groupForm.tsx",
              element: element,
            },
          });
          if (element.name.trim() == "") {
            error = true;
          }
        });

        if (values.name.trim() == "" || error) {
          setErrorAlertOpen(true);
          setSnackbarMessage("Please fill all the required fields.");
          appLogger.error(
            {
              errObj: {
                method: "useFormik",
                component: "groups",
                fileName: "groupForm.tsx",
              },
            },
            "Please fill all the required fields."
          );
        } else {
          props.createGroup(values);
        }
        // props.snackbarShowMessage("Groups Created Successfully", "success");
        // setTimeout(function () {
        //   handleDrawerClose();
        // }, 1000);
      } catch (error) {
        appLogger.error({
          errObj: {
            method: "useFormik",
            component: "groups",
            fileName: "groupForm.tsx",
            err: error,
          },
        });
        setIsloading(true);
      }
    },
  });

  const changeselectedProducts = (data: any, grpId: string) => {
    appLogger.info({
      infoObj: {
        method: "changeselectedProducts",
        component: "groups",
        fileName: "groupForm.tsx",
        data: data,
      },
    });
    const temp = [...groupProdList];
    if (data.length < formik.values.products.length) {
      appLogger.info({
        infoObj: {
          method: "changeselectedProducts",
          component: "groups",
          fileName: "groupForm.tsx",
          products: formik.values.products,
        },
      });
      formik.values.products.map((prod: any) => {
        if (prod && prod.groups && prod.groups.length > 0) {
          temp.map((tmpProd: any, index: number) => {
            if (tmpProd.id === prod.id) {
              if (temp[index].groups) {
                temp[index].groups = [];
              }
            }
          });
        }
      });
    }
    if (data.length > 0) {
      data.map((prod: any) => {
        if (prod) {
          temp.map((tmpProd: any, index: number) => {
            if (tmpProd.id === prod.id && tmpProd.version === tmpProd.version) {
              temp[index].groups = [prod.id];
            }
          });
        }
      });
    }
    appLogger.info({
      infoObj: {
        method: "changeselectedProducts",
        component: "groups",
        fileName: "groupForm.tsx",
        temp: temp,
      },
    });
    setGroupProdList(temp);
    formik.values.products = data;
  };

  const addTableRows = () => {
    const subGroupInputs: any = {
      name: "",
      products: [],
    };
    setsubGrouprowsData([...subGrouprowsData, subGroupInputs]);
  };

  const deleteTableRows = (index: any) => {
    const rows = [...subGrouprowsData];
    rows.splice(index, 1);
    appLogger.info({
      infoObj: {
        method: "deleteTableRows",
        component: "groups",
        fileName: "groupForm.tsx",
        subGrouprowsData: rows,
      },
    });
    setsubGrouprowsData(rows);
  };

  const handleChange = (index: any, evnt: any, type: any) => {
    //changeselectedProducts(value, formik.values.id)
    const subGroupInputs: any = [...subGrouprowsData];
    if (type != "product") {
      const { name, value } = evnt.target;
      subGroupInputs[index][name] = value;
    } else {
      const temp = [...groupProdList];
      if (
        evnt &&
        subGroupInputs[index]["products"] &&
        evnt.length < subGroupInputs[index]["products"].length
      ) {
        subGroupInputs[index]["products"].map((prod: any) => {
          if (prod) {
            temp.map((tmpProd: any, index: number) => {
              if (tmpProd.id === prod.id && tmpProd.version === prod.version) {
                temp[index].groups = [];
              }
            });
          }
        });
      }
      if (evnt.length > 0) {
        evnt.map((prod: any) => {
          if (prod) {
            temp.map((tmpProd: any, index: number) => {
              if (tmpProd.id === prod.id && tmpProd.version === prod.version) {
                temp[index].groups = [prod.id];
              }
            });
          }
        });
      }
      setGroupProdList(temp);
      subGroupInputs[index]["products"] = evnt;
    }
    appLogger.info({
      infoObj: {
        method: "handleChange",
        component: "groups",
        fileName: "groupForm.tsx",
        subGroupInputs: subGroupInputs,
      },
    });
    setsubGrouprowsData(subGroupInputs);
    formik.values.subGroups = subGroupInputs;
  };

  const subGrpEndRef = useRef<any>(null);
  const scrollToBottom = () => {
    subGrpEndRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(scrollToBottom, [subGrouprowsData]);

  return (
    <Grid>
      <Drawer
        className={isLoading ? "loader user-popup" : "user-popup"}
        anchor="right"
        open={props.addOpen}
        onClose={handleDrawerClose}
      >
        <Box sx={{ width: "100%" }}>
          <Box
            className="title-wrap"
            sx={{
              display: "flex",
              alignItems: "center",
              borderBottom: 1,
              borderColor: "divider",
            }}
          >
            <Typography className="title">
              {props.editData ? "Edit Group" : "Create Group"}
            </Typography>
            <IconButton className="close-filter" onClick={handleDrawerClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>

        <Grid
          sx={{ p: 3 }}
          item
          // className={isLoading ? "loader user-form" : "user-form"}
        >
          <Grid container spacing={2}>
            <Grid item xs={12} md={12} className="group-form">
              <Box
                component="form"
                onSubmit={formik.handleSubmit}
                method="post"
                noValidate
                sx={{ mt: "10px" }}
              >
                <TextField
                  sx={{ width: "100%" }}
                  className="custom-select"
                  required
                  id="outlined-required"
                  label="Group Name"
                  {...formik.getFieldProps("name")}
                  // error={
                  //   formik.touched.name && formik.errors.name ? true : false
                  // }
                  // helperText="Incorrect entry."
                />
                {/* {error && <FormHelperText error>{helperText}</FormHelperText>} */}

                {/* <CustomInput
                  placeholder="Group Name"
                  label="Group Name"
                  type="text"
                  id="name"
                  autoComplete="name"
                  {...formik.getFieldProps("name")}
                  error={
                    formik.touched.name && formik.errors.name ? true : false
                  }
                  helperText={
                    formik.touched.name && formik.errors.name
                      ? formik.errors.name
                      : null
                  }
                /> */}
                <Box sx={{ mt: "12px" }}>
                  <FormControl className="custom-select" fullWidth>
                    {/* <FormLabel className="group-sub-prod">Products</FormLabel> */}
                    <Autocomplete
                      className="search-prod-box"
                      onChange={(event, value) =>
                        changeselectedProducts(value, formik.values.id)
                      }
                      multiple
                      options={filteredProdList(
                        formik.values,
                        formik.values.products
                      )}
                      getOptionLabel={(option: any) =>
                        option && option.version
                          ? `${option.name} - ${option.version}`
                          : ""
                      }
                      isOptionEqualToValue={(option: any, value: any) =>
                        option?.id === value?.id
                      }
                      defaultValue={
                        props.editData ? props.editData.products : []
                      }
                      renderInput={(params: any) => (
                        <TextField
                          className="search-prod-box custom-select"
                          value={formik.values.products}
                          {...params}
                          placeholder=""
                          // label="Products"
                          // placeholder="Search Products"
                          // error={
                          //   formik.touched.product && formik.errors.product
                          //     ? true
                          //     : false
                          // }
                          // helperText={
                          //   formik.touched.product && formik.errors.product
                          //     ? formik.errors.product
                          //     : null
                          // }
                        />
                      )}
                    />
                  </FormControl>
                </Box>
                <Box>
                  {props.editData !== "" && (
                    <Button
                      variant="contained"
                      onClick={addTableRows}
                      sx={{
                        mt: "15px",
                        mb: "10px",
                        // ml: "15px",
                        backgroundColor: (theme: any) =>
                          theme.palette.primary.main,
                        textTransform: "uppercase",
                      }}
                    >
                      + Add Sub Group
                    </Button>
                  )}
                  {subGrouprowsData.map((data: any, index: any) => {
                    const { name, products } = data;
                    return (
                      <Box sx={{ p: 2 }} className="sub-group-card" key={index}>
                        <>
                          <span
                            className="sub-group-close"
                            onClick={(e) => {
                              if (data.id) {
                                props.handleDeletePopup(e, data);
                              } else {
                                deleteTableRows(index);
                              }
                            }}
                          >
                            <CloseIcon className="cursor-pointer" />
                          </span>

                          <TextField
                            sx={{ width: "95%" }}
                            name="name"
                            className="custom-select"
                            required
                            id="name"
                            label="Group Name"
                            autoComplete="name"
                            // {...formik.getFieldProps("name")}
                            onChange={(evnt: any) =>
                              handleChange(index, evnt, "name")
                            }
                            value={name}
                          />

                          {/* <CustomInput
                            name="name"
                            placeholder="Group Name"
                            label="Group Name"
                            type="text"
                            id="name"
                            autoComplete="name"
                            onChange={(evnt) =>
                              handleChange(index, evnt, "name")
                            }
                            // {...formik.getFieldProps("name")}
                            error={
                              formik.touched.name && formik.errors.name
                                ? true
                                : false
                            }
                            helperText={
                              formik.touched.name && formik.errors.name
                                ? formik.errors.name
                                : null
                            }
                            value={name}
                          /> */}
                          <Box sx={{ mt: "12px" }}>
                            <FormControl className="custom-select" fullWidth>
                              {/* <FormLabel className="group-sub-prod">
                              Products
                            </FormLabel> */}
                              <Autocomplete
                                onChange={(event, value) =>
                                  handleChange(index, value, "product")
                                }
                                // onChange={(event, value) =>
                                //   changeselectedProducts(value, formik.values.id)
                                // }
                                multiple
                                options={filteredProdList(data, products)}
                                getOptionLabel={(option: any) =>
                                  option && option.version
                                    ? `${option.name} - ${option.version}`
                                    : ""
                                }
                                isOptionEqualToValue={(
                                  option: any,
                                  value: any
                                ) => option?.id === value?.id}
                                defaultValue={products}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder=""
                                    label="Products"
                                    // error={
                                    //   formik.touched.product &&
                                    //   formik.errors.product
                                    //     ? true
                                    //     : false
                                    // }
                                    // helperText={
                                    //   formik.touched.product &&
                                    //   formik.errors.product
                                    //     ? formik.errors.product
                                    //     : null
                                    // }
                                  />
                                )}
                              />
                            </FormControl>
                          </Box>
                        </>
                        <div ref={subGrpEndRef} />
                      </Box>
                    );
                  })}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    mt: 1,
                  }}
                  className="footer-action-btn"
                >
                  <Button variant="outlined" onClick={handleDrawerClose}>
                    cancel
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      mt: "15px",
                      mb: "15px",
                      backgroundColor: (theme: any) =>
                        theme.palette.primary.main,
                      textTransform: "uppercase",
                    }}
                  >
                    save
                  </Button>
                </Box>

                <Snackbar
                  anchorOrigin={{ vertical: "top", horizontal: "center" }}
                  open={alertOpen}
                  autoHideDuration={2000}
                  onClose={handleAlertClose}
                >
                  <Alert onClose={handleAlertClose} severity="success">
                    {snackbarMessage}
                  </Alert>
                </Snackbar>

                <Snackbar
                  anchorOrigin={{ vertical: "top", horizontal: "center" }}
                  open={errorAlertOpen}
                  autoHideDuration={2000}
                  onClose={handleErrorAlertClose}
                >
                  <Alert onClose={handleErrorAlertClose} severity="error">
                    {snackbarMessage}
                  </Alert>
                </Snackbar>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Drawer>
    </Grid>
  );
};
export default withSnackbar(GroupForm);
